import { Component } from '@angular/core';

@Component({
  selector: 'app-street-naming-portal',
  templateUrl: './street-naming-portal.component.html',
  standalone: false,
})
export class StreetNamingPortalComponent {}
